<template>
  <page-section :title="$t('Profiles_Title_Aggregates')">
    <rest-list
      :payload="fetchEndpoint"
      ref="rest-list"
      :filterable="true"
      :apply-filters-to-url="false"
    >
      <rest-list-column
        prop="name"
        :title="$t('ProfileAttributes_Attribute_NameLabel')"
        :min-width="180"
      />

      <rest-list-column
        prop="value"
        :title="$t('ProfileAttributes_Field_Value')"
        :min-width="180"
        :tooltip="true"
      >
        <template slot-scope="{ row }">
          <overflow-tooltip :value="personalDataFormatter(getValue(row))" />
        </template>
      </rest-list-column>

      <rest-list-column-date
        v-if="timestampEnabled"
        prop="timestamp"
        :title="$t('ProfileAttributes_Field_ComputedAt')"
        :width="200"
        :unix="false"
      />
    </rest-list>
  </page-section>
</template>

<script>
import PageSection from '@/common/components/page/PageSection'
import RestList from '@/common/components/rest/RestList'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate'
import OverflowTooltip from '@/common/components/form/OverflowTooltip'
import { projectEndpoint } from '@/core/helpers'
import { taskStatusEnum } from '@/modules/tasks/enum/TaskRecordEnums'

export default {
  name: 'ProfileAggregatesList',

  data() {
    return {
      taskStatusEnum
    }
  },

  components: {
    OverflowTooltip,
    RestListColumnDate,
    RestList,
    PageSection,
    RestListColumn
  },

  props: {
    readonly: {
      type: Boolean,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `profiles/${this.$route.query.profile_id}/aggregates`,
        params: {
          sort: 'name'
        }
      })
    },

    timestampEnabled() {
      return this.$store.state.app.features.jsonAggregates !== 2
    }
  },

  methods: {
    getValue(row) {
      return row.error ? '❗' + row.error : row.value
    },

    personalDataFormatter(value) {
      if (value === null || value === '') {
        return '-'
      } else if (this.$can('UserPersonalData::Read')) {
        return value
      } else {
        return '******'
      }
    }
  }
}
</script>

<style scoped>
.page-section {
  border: 1px solid #dbdee7;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/modules/profiles/components/ProfileAggregatesList.vue